export enum StaticModal {
    USER_FEEDBACK = 'user-feedback',
    IMPORT_VALIDATION = 'import-validation',
    IMPORT_LIMIT_REACHED = 'import-limit-reached',
    DELETE_SECRETS = 'delete-secrets',
    REMOVE_TAG = 'remove-tag',
    UPDATE_TAG = 'update-tag',
    VIEW_FILTER = 'view-filter',
    HIDE_GROUP = 'hide-group',
    CREATE_API_KEY = 'create-api-key',
    /** One key for both vault modes — the payload's vault decides which. */
    VAULT_FORM = 'vault-form',
    VAULT_IMPORT = 'vault-import',

    SUBSCRIPTION_UPGRADE = 'subscription-upgrade',
    TRIAL = 'trial',
}
